module.exports = __webpack_public_path__ + "img/01.ff2930f4.jpg";